
		<cdk-virtual-scroll-viewport [itemSize]="columnHeight">
	<table>
		<thead>
			<tr>
				<th></th>
			</tr>
		</thead>
		<tbody>
				<tr *cdkVirtualFor="let column of columns">
					<td></td>
				</tr>
		</tbody>
</table>
		</cdk-virtual-scroll-viewport>


